import type { IIdName } from "~/client/resources";

export const toSelectItem = <T extends IIdName>(item: T) => ({ value: item.Id, text: item.Name });

export default toSelectItem;
